import { useEffect, useCallback, useRef } from "react";

// Ver TAREA: vinculación de Google desde el perfil -- extraído de
// Login/index.js (login) para que Login y la sección "Acceso con
// Google" de UserModal (vinculación) compartan la MISMA
// inicialización de Google Identity Services (GIS) en vez de cada uno
// tener su propio useEffect/triggerGoogleLogin copiado.
//
// `onCredential` recibe el idToken crudo (response.credential); qué se
// hace con él (login vs. vincular la cuenta ya logueada) lo decide
// quien use el hook, no este archivo. Se guarda en un ref para que
// `accounts.id.initialize()` -- que sigue corriendo UNA sola vez, igual
// que el código original -- siempre dispare la versión más reciente del
// callback aunque el componente que llama al hook se re-renderice con
// una función nueva (el Login original no tenía este problema porque
// handleGoogleLogin viene de un Context estable, pero el uso nuevo en
// UserModal sí puede recrear el callback en cada render).
export default function useGoogleIdentity(onCredential) {
  const onCredentialRef = useRef(onCredential);
  onCredentialRef.current = onCredential;

  useEffect(() => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    if (!clientId) return;

    const initGoogle = () => {
      if (!window.google?.accounts?.id) return;
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (response) => onCredentialRef.current(response.credential),
      });
    };

    if (window.google?.accounts?.id) {
      initGoogle();
    } else {
      const script = document.querySelector('script[src*="accounts.google.com/gsi/client"]');
      script?.addEventListener("load", initGoogle);
      return () => script?.removeEventListener("load", initGoogle);
    }
  }, []);

  const trigger = useCallback(() => {
    if (!window.google?.accounts?.id) return;
    window.google.accounts.id.prompt((notification) => {
      if (notification.isNotDisplayed()) {
        console.warn("[GoogleSignIn] not displayed:", notification.getNotDisplayedReason());
      } else if (notification.isSkippedMoment()) {
        console.warn("[GoogleSignIn] skipped:", notification.getSkippedReason());
      } else if (notification.isDismissedMoment()) {
        console.warn("[GoogleSignIn] dismissed:", notification.getDismissedReason());
      }
    });
  }, []);

  return trigger;
}
